var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRcm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-2h40v40H-1z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M0 27.391h21.132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80959D",
    fillRule: "nonzero",
    d: "M8.487 2.83a.487.487 0 1 0 0-.974.487.487 0 0 0 0 .974z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.783,
    cy: 30.913,
    r: 1.174,
    fill: "#80959D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(21, 87, 191, 0.7)",
    d: "M32.133 13.21v-2.202H11.815v12.28h17.183M31.996 24.217V16.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(21, 87, 191, 0.7)",
    fillRule: "nonzero",
    d: "M12.53 11.342l9.583 7.105 9.67-7.105zM28.377 18.83l3.669-3.813 3.625 3.812z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M21.127 8.616V0H0v33.652h21.13v-8.635M0 4.696h20.95M10.4 2.383h3.13"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcm);
export default __webpack_public_path__ + "static/media/rcm.5a222221aed1385d8acfe4ef1fd0a973.svg";
export { ForwardRef as ReactComponent };